import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {getInitialState} from '@web/slices/moneyToken/slice'

import type {MoneyTokenReducers, MakeSliceOptions} from './interfaces'
import type {MoneyTokenState} from '@web/slices/moneyToken/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<MoneyTokenState, MoneyTokenReducers, 'moneyToken', SliceSelectors<MoneyTokenState>>({
        name: 'moneyToken',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.moneyToken
            })
        },
    })
